import(/* webpackMode: "eager" */ "/home/r11/choice-graphics/node_modules/.pnpm/next@16.2.7_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@playwright+test@1.60.0_react-d_a91a578b9f152ddae170ad48d856e636/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["EditableText"] */ "/home/r11/choice-graphics/src/components/content-edit/editable-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Icon"] */ "/home/r11/choice-graphics/src/components/ui/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroNebula"] */ "/home/r11/choice-graphics/src/components/v2/hero-nebula.tsx");
